export const categories = [
  {
    id: 'beauty',
    name: '美容',
    icon: 'ri-heart-pulse-line',
    description: '面部护理、抗衰紧致、水光针、光子嫩肤等专业美容项目',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20spa%20facial%20treatment%20room%20with%20soft%20warm%20lighting%2C%20white%20towels%2C%20serene%20atmosphere%2C%20modern%20minimalist%20interior%20design%2C%20professional%20beauty%20salon%20setting%2C%20clean%20elegant%20aesthetic%2C%20gentle%20rose%20and%20cream%20tones&width=800&height=600&seq=cat-beauty-01&orientation=landscape',
  },
  {
    id: 'hair',
    name: '美发',
    icon: 'ri-scissors-cut-line',
    description: '发型设计、染发烫发、头皮护理、接发等一站式美发服务',
    image: 'https://readdy.ai/api/search-image?query=Modern%20luxury%20hair%20salon%20interior%20with%20warm%20ambient%20lighting%2C%20stylish%20mirrors%2C%20elegant%20decoration%2C%20professional%20hairdressing%20station%2C%20clean%20minimalist%20design%2C%20cream%20and%20gold%20color%20palette&width=800&height=600&seq=cat-hair-01&orientation=landscape',
  },
  {
    id: 'nail',
    name: '美甲',
    icon: 'ri-paint-brush-line',
    description: '精致美甲、甲面护理、延长甲、艺术美甲等潮流美甲服务',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20nail%20art%20salon%20with%20soft%20natural%20lighting%2C%20display%20of%20beautiful%20manicure%20designs%2C%20pastel%20color%20palette%2C%20modern%20minimalist%20interior%2C%20professional%20nail%20care%20station%2C%20warm%20cream%20and%20blush%20tones&width=800&height=600&seq=cat-nail-01&orientation=landscape',
  },
  {
    id: 'body',
    name: '美体',
    icon: 'ri-body-scan-line',
    description: '身体护理、SPA按摩、纤体塑形、经络疏通等身心放松服务',
    image: 'https://readdy.ai/api/search-image?query=Tranquil%20spa%20body%20treatment%20room%20with%20candles%20and%20soft%20lighting%2C%20massage%20table%20with%20white%20linens%2C%20serene%20zen%20atmosphere%2C%20natural%20elements%20decor%2C%20warm%20neutral%20tones%2C%20luxurious%20wellness%20center&width=800&height=600&seq=cat-body-01&orientation=landscape',
  },
];

export const services = [
  {
    id: 1,
    category: 'beauty',
    name: '深层补水焕肤护理',
    description: '采用进口玻尿酸精华，配合专业仪器导入，深层补水锁水，重现水润光泽肌。',
    price: 298,
    originalPrice: 498,
    duration: '60分钟',
    rating: 4.9,
    reviewCount: 1286,
    store: '花漾美容会所',
    image: 'https://readdy.ai/api/search-image?query=Professional%20facial%20skincare%20treatment%20with%20soft%20warm%20lighting%2C%20woman%20receiving%20facial%20mask%20treatment%2C%20serene%20beauty%20salon%20atmosphere%2C%20clean%20white%20interior%2C%20cream%20and%20blush%20tones&width=600&height=400&seq=svc-beauty-01&orientation=landscape',
  },
  {
    id: 2,
    category: 'beauty',
    name: '光子嫩肤全脸护理',
    description: '采用先进光子技术，改善肤色不均、淡化色斑、收缩毛孔，打造细腻透亮肌。',
    price: 398,
    originalPrice: 688,
    duration: '45分钟',
    rating: 4.8,
    reviewCount: 956,
    store: '星颜医疗美容',
    image: 'https://readdy.ai/api/search-image?query=Advanced%20skin%20rejuvenation%20treatment%20in%20modern%20clinic%2C%20professional%20aesthetic%20equipment%2C%20clean%20medical%20spa%20environment%2C%20soft%20clinical%20lighting%2C%20white%20and%20cream%20interior&width=600&height=400&seq=svc-beauty-02&orientation=landscape',
  },
  {
    id: 3,
    category: 'beauty',
    name: '韩式半永久定妆眉',
    description: '资深纹绣师一对一设计眉形，使用天然植物色料，效果自然持久，免去每日画眉烦恼。',
    price: 1680,
    originalPrice: 2280,
    duration: '90分钟',
    rating: 4.9,
    reviewCount: 2035,
    store: '韩秀半永久工作室',
    image: 'https://readdy.ai/api/search-image?query=Professional%20eyebrow%20microblading%20procedure%20in%20clean%20beauty%20studio%2C%20closeup%20of%20beautiful%20natural%20eyebrows%2C%20soft%20warm%20lighting%2C%20modern%20minimalist%20interior%2C%20cream%20and%20rose%20tones&width=600&height=400&seq=svc-beauty-03&orientation=landscape',
  },
  {
    id: 4,
    category: 'hair',
    name: '日系空气感烫发',
    description: '日籍发型师主理，采用低损伤烫发技术，打造自然蓬松的空气感卷发造型。',
    price: 588,
    originalPrice: 880,
    duration: '120分钟',
    rating: 4.7,
    reviewCount: 876,
    store: '东京造型美发沙龙',
    image: 'https://readdy.ai/api/search-image?query=Professional%20hair%20perm%20styling%20in%20modern%20Japanese%20salon%2C%20beautiful%20wavy%20hair%20result%2C%20warm%20ambient%20lighting%2C%20elegant%20interior%20design%2C%20cream%20and%20beige%20tones&width=600&height=400&seq=svc-hair-01&orientation=landscape',
  },
  {
    id: 5,
    category: 'hair',
    name: '巴黎画染全头染发',
    description: '采用巴黎画染技法，自然渐变过渡，打造高级感发色，显白不挑肤色。',
    price: 980,
    originalPrice: 1480,
    duration: '180分钟',
    rating: 4.8,
    reviewCount: 1523,
    store: 'COLORIST染发专门店',
    image: 'https://readdy.ai/api/search-image?query=Professional%20balayage%20hair%20coloring%20in%20luxury%20salon%2C%20beautiful%20gradient%20hair%20color%20result%2C%20modern%20salon%20interior%2C%20warm%20natural%20lighting%2C%20cream%20and%20gold%20tones&width=600&height=400&seq=svc-hair-02&orientation=landscape',
  },
  {
    id: 6,
    category: 'nail',
    name: '日式精致美甲套餐',
    description: '包含甲面护理、修形、底胶加固、日式精致款式设计，使用日本进口甲油胶。',
    price: 268,
    originalPrice: 398,
    duration: '75分钟',
    rating: 4.9,
    reviewCount: 3210,
    store: 'Nail Art美甲工作室',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20Japanese%20style%20nail%20art%20design%20display%20with%20elegant%20manicure%20results%2C%20soft%20pastel%20colors%2C%20professional%20nail%20salon%20setup%2C%20warm%20lighting%2C%20cream%20and%20blush%20pink%20tones&width=600&height=400&seq=svc-nail-01&orientation=landscape',
  },
  {
    id: 7,
    category: 'nail',
    name: '奢华镶钻美甲',
    description: '高级定制美甲，采用施华洛世奇水晶镶嵌，搭配精致手绘图案，闪耀动人。',
    price: 498,
    originalPrice: 698,
    duration: '90分钟',
    rating: 4.7,
    reviewCount: 1867,
    store: 'Nail Art美甲工作室',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20diamond%20encrusted%20nail%20art%20design%2C%20elegant%20manicure%20with%20crystals%2C%20glamorous%20nail%20salon%20setting%2C%20soft%20sparkling%20lighting%2C%20cream%20and%20champagne%20tones&width=600&height=400&seq=svc-nail-02&orientation=landscape',
  },
  {
    id: 8,
    category: 'body',
    name: '泰式古法全身按摩',
    description: '泰国资深按摩师主理，运用古法拉伸与穴位按压，深层放松全身肌肉疲劳。',
    price: 358,
    originalPrice: 528,
    duration: '90分钟',
    rating: 4.8,
    reviewCount: 2341,
    store: '泰尊SPA会馆',
    image: 'https://readdy.ai/api/search-image?query=Tranquil%20Thai%20massage%20room%20with%20traditional%20decor%2C%20massage%20mats%20with%20white%20linens%2C%20candles%20and%20soft%20lighting%2C%20serene%20zen%20atmosphere%2C%20warm%20earth%20tones%2C%20natural%20elements&width=600&height=400&seq=svc-body-01&orientation=landscape',
  },
  {
    id: 9,
    category: 'body',
    name: '热石能量纤体护理',
    description: '采用天然火山热石结合精油按摩，促进新陈代谢，帮助排毒纤体，焕发身体活力。',
    price: 468,
    originalPrice: 698,
    duration: '75分钟',
    rating: 4.6,
    reviewCount: 1432,
    store: '悦容SPA养生馆',
    image: 'https://readdy.ai/api/search-image?query=Luxurious%20hot%20stone%20massage%20treatment%20in%20spa%20room%2C%20smooth%20stones%20on%20back%2C%20soft%20candlelight%2C%20serene%20wellness%20atmosphere%2C%20warm%20neutral%20tones%2C%20cream%20and%20beige&width=600&height=400&seq=svc-body-02&orientation=landscape',
  },
  {
    id: 10,
    category: 'body',
    name: '芳香精油SPA套餐',
    description: '精选天然植物精油，包含全身按摩+面部护理+头部放松，沉浸式芳香SPA体验。',
    price: 598,
    originalPrice: 888,
    duration: '120分钟',
    rating: 4.9,
    reviewCount: 2890,
    store: '花漾SPA会所',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20aromatherapy%20spa%20treatment%20room%20with%20essential%20oils%20and%20flowers%2C%20soft%20candlelight%2C%20serene%20relaxation%20atmosphere%2C%20cream%20and%20soft%20pink%20tones%2C%20elegant%20wellness%20center&width=600&height=400&seq=svc-body-03&orientation=landscape',
  },
];